import React from 'react'
import Button from '../Button/Button'
import Image from '../MyImage/Image'
import { Link } from 'react-scroll'
import './Hero.css'

const Hero = ({button}) => {
    return (
        <section className="hero">
            <div id="container" className="hero-container">
                <div className="hero__text">
                    <h1>Hey, I'm Adda Younes</h1>
                    <p>I'm a Frontend Web Developer who is addicted to learning and loves working with people. I live by the motto Learn Build Grow, so I’m excited to help you with things I learnt!</p>
                    {button && <Link to="portfolio" smooth={true} duration={500} offset={0}><Button  className="btn" to="" label="Portfolio" firstStyle={false} buttonGroup={true} /></Link>}
                    {button && <Button className="btn" label="Get in touch" firstStyle={true} to="contact" />}
                </div>
                <div className="hero__photo">
                    <Image />
                </div>
            </div>
        </section>
    )
}

Hero.defaultProps = {
    button: true
}

export default Hero
